import { useEffect, useState } from "react";
import Cardlist from "../components/CardList";
import Footer from "../components/FooterComponent";
import NavBar from "../components/NavBar";
// import bg_hp from "../../public/bh-hp.jpg";

export default function HomePage() {
  // const [movie, setMovie] = useState([]);

  // useEffect(() => {}, []);

  return (
    <>
      {/* header Nav */}
      <NavBar></NavBar>
      {/* End headre Nav */}
      {/* <div className="relative w-full overflow-hidden mb-2">
        <div className="relative float-left w-full"> */}
      <div className="w-screen h-80 bg-bg-hp"></div>
      <div className="mt-4">
        <h1 className="text-lg uppercase font-black">Top Movies</h1>
        <p>News in Week</p>
      </div>
      {/* <img
            src="../../public/bg-hp"
            className="block w-full"
            alt="Exotic Fruits"
          /> */}
      {/* </div>
      </div> */}
      <Cardlist></Cardlist>
      <Footer></Footer>
    </>
  );
}
